export default "__VITE_ASSET__cfb646f9__"